import MaterialsApiService from "./api/MaterialsApiService";
import { materialsServiceReverb } from "./api/MaterialsApiService";
import store from "@/store";

export const getForumsData = async (payload) => {
    try {
        let url = '/forums?'

        if (payload?.disciplineId) {
            url += `discipline=${payload.disciplineId}&`
        }

        if (payload?.status) {
            url += `status=${payload.status}&`
        }

        if (payload?.page) {
            url += `page=${payload.page}&`
        }

        if(payload?.perPage) {
            url += `per_page=${payload.perPage}&`
        }

        if(payload?.sort) {
            url += `sort=${payload.sort}&`
        }

        if(payload?.visible) {
            url += `visible=${payload.visible}&`
        }

        const response = await MaterialsApiService.get(url)
        return response.data
    } catch {
        throw new Error("Aconteceu um erro ao requisitar forums! Tente novamente")
    }
}

export const createForum = async (payload) => {
    try {
        const response = await MaterialsApiService.post('/forums', payload, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
        return response.data
    } catch {
        throw new Error("Ocorreu um erro ao criar o fórum! Tente novamente")
    }
}

export const getForum = async (forumId) => {
    try {
        const response = await MaterialsApiService.get(`/forums/${forumId}`)
        return response.data
    } catch {
        throw new Error("Ocorreu um erro ao requisitar fórum! Tente novamente")
    }
}

export const createForumComment = async (payload) => {
    try {
        const response = await MaterialsApiService.post('/forums-comments', payload, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })

        return response.data
    } catch {
        throw new Error("Aconteceu um erro ao criar comentário! Tente novamente")
    }
}

export const getCommentsRelatedToForum = async (payload) => {
    try {
        let url = '/forums-comments?'

        if(payload?.forumId) {
            url += `forum=${payload.forumId}&`
        }

        if(payload?.numChildren !== undefined || payload?.numChildren !== null ) {
            url += `num_children=${payload.numChildren}&`
        }

        if(payload?.page) {
            url += `page=${payload.page}&`
        }

        if(payload.perPage) {
            url += `per_page=${payload.perPage}&`
        }

        url += `parent=${payload?.parent || ''}&`

        const response = await MaterialsApiService.get(url)
        return response.data
    } catch {
        throw new Error("Erro ao requisitar comentários associados ao fórum! Tente novamente")
    }
}

export const voteCommentInForum = async (payload) => {
    try {
        const response = await MaterialsApiService.put(`/forums-comments/${payload.commentId}/vote`, payload)
        return response.data
    } catch {
        throw new Error("Erro ao votar no comentário! Tente novamente")
    }
}

export const deleteForum = async (payload) => {
    try {
        const response = await MaterialsApiService.delete(`/forums/${payload.forumId}`)
        return response.data
    } catch {
        throw new Error("Ocorreu um erro ao excluir o fórum! Tente novamente")
    }
}

export const updateForum = async (payload) => {
    try {
        const response = await MaterialsApiService.post(`forums/${payload.forumId}`, payload, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
        return response.data
    } catch {
        throw new Error("Ocorreu um erro ao atualizar fórum! Tente novamente")
    }
}

export const deleteForumComment = async (forumCommentId) => {
    try {
        const response = await MaterialsApiService.delete(`/forums-comments/${forumCommentId}`)
        return response.data
    } catch {
        throw new Error("Erro ao excluir comentário! Tente novamente")
    }
}

export const updateForumVisibility = async (payload) => {
    try {
        const response = await MaterialsApiService.put(`/forums-comments/${payload.forumCommentId}/visibility`, payload)
        return response.data
    } catch {
        throw new Error("Erro ao mudar visibilidade do comentário! Tente novamente")
    }
}

export const updateForumComment = async (payload) => {
    try {
        const response = await MaterialsApiService.post(`/forums-comments/${payload.forumCommentId}`, payload, {
            headers: {
                ...payload.file && {'Content-Type': 'multipart/form-data'},
            }
        })
        return response.data
    } catch (error) {
        throw new Error("Erro ao atualizar comentário! Tente novamente")
    }
}

export const listenToForumUpdate = (channel, events) => {
    const localMaterialServiceInstance = materialsServiceReverb()

    if (!localMaterialServiceInstance) return
    try { 
        const privateChannel = localMaterialServiceInstance.private(channel)
        events.forEach((event) => {
            privateChannel.listen(event.eventName, (wsEvent) => {
                console.log(`${event.eventName}: }`, wsEvent)
                store.dispatch(event.eventAction, {...wsEvent, eventName: event.eventName})
            })
        })
    } catch {
        store.dispatch('toastfy/activeErrorNotification', { text: "Ocorreu um erro ao sincronizar usuarios" })
    }
}

export const markForumAsRead = async (forumId) => {
    try {
        const response = await MaterialsApiService.put(`/forums/${forumId}/read`)
        return response.data
    } catch {
        throw new Error("Ocorreu um erro ao marcar fórum como lido! Tente novamente")
    }
}